// extracted by mini-css-extract-plugin
module.exports = {"clear-filter":"clear-search-filters_clear-filter___hT7A"};